<template>
    <div class="quickscan-step2">
        <h1>Aanvraag quickscan</h1>
        <h2>Controle</h2>

        <quickscan-stepper :current-step="2" :loading="!loaded">
            <v-error-messages ref="errorMessages" :messages="this.errorMessages"></v-error-messages>

            <v-form @submit.prevent="submit">
                <h3>Contactgegevens contactpersoon</h3>
                <v-text-field :error="hasErrors('name')" :error-messages="handleErrors('name')" v-model="contact.name" label="Achternaam" required></v-text-field>
                <v-radio-group :error="hasErrors('gender')" :error-messages="handleErrors('gender')" label="Geslacht" v-model="contact.gender" row>
                    <v-radio key="male" label="man" value="male"></v-radio>
                    <v-radio key="female" label="vrouw" value="female"></v-radio>
                    <v-radio key="other" label="gender neutraal" value="other"></v-radio>
                </v-radio-group>
                <v-text-field v-model="contact.phone" :error="hasErrors('phone')" :error-messages="handleErrors('phone')" label="Telefoonnummer" required></v-text-field>
                <v-text-field v-model="contact.email" :error="hasErrors('email')" :error-messages="handleErrors('email')" label="E-mailadres" required></v-text-field>

                <v-row>
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                        <v-btn @click="back" :loading="backBtnClicked" :disabled="submitting">Terug</v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn color="primary" @click="submit" :loading="submitBtnClicked" :disabled="submitting"
                        >Verzenden
                        </v-btn
                        >
                    </v-col>
                </v-row>
            </v-form>
        </quickscan-stepper>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import QuickscanStepper from '../components/QuickscanStepper';
import VErrorMessages from '@/components/VErrorMessages';

export default {
    name: 'quickscan-step2',
    components: {
        QuickscanStepper,
        VErrorMessages,
    },
    data: () => ({
        loaded: false,
        backBtnClicked: false,
        submitBtnClicked: false,
        submitting: false,

        errorMessages: [],
        contact: {
            name: null,
            gender: null,
            phone: null,
            email: null,
        },
        application: {
            shortDescription: null,
            enteredTruthfully: null,
        },
        errorDetails: {},
    }),
    computed: {
        ...mapGetters({vuex: 'step2'}),
    },
    created: function () {
        let that = this;
        this.quickscanStep2Load().then(function () {
            let contact = that.vuex.contact;
            const application = that.vuex.application;

            //redirect to step3
            if(!that.vuex.applicant.hasOtherContact)
              that.$router.push({name: 'quickscan_step3'});

            that.contact.name = contact.name;
            that.contact.gender = contact.gender;
            that.contact.phone = contact.phone;
            that.contact.email = contact.email;
            that.application.shortDescription = application.shortDescription;
            that.application.enteredTruthfully = application.enteredTruthfully;

            that.loaded = true;
        });
    },
    methods: {
        ...mapActions(['quickscanStep2Load', 'quickscanStep2Submit']),
        hasErrors(name) {
            return '' !== this.handleErrors(name);
        },
        handleErrors(name) {
            if (this.errorDetails[name] !== undefined) {
                let error = '';
                Object.entries(this.errorDetails[name]).forEach(entry => {
                    const [errorType, value] = entry;
                    error += " " + value;
                });
                return error;
            }
            return '';
        },
        getPayload: function () {
            return {
                data: {
                    contact: {
                        name: this.contact.name,
                        gender: this.contact.gender,
                        phone: this.contact.phone,
                        email: this.contact.email,
                    }
                }
            };
        },
        back: function () {
            const that = this;
            this.backBtnClicked = true;
            this.submitting = true;
            this.errorMessages = [];

            this.quickscanStep2Submit(this.getPayload()).finally(function () {
                that.$router.push({name: 'quickscan_step1'});
                that.backBtnClicked = false;
                that.submitting = false;
            });
        },
        submit: function () {
            const that = this;
            this.submitBtnClicked = true;
            this.submitting = true;
            this.errorMessages = [];

            this.quickscanStep2Submit(this.getPayload())
                .then(function () {
                    that.$router.push({name: 'quickscan_step3'});
                })
                .catch(function (error) {
                    const response = error.response;
                    if (response.data !== undefined && response.data.error !== undefined) {
                        that.errorDetails = response.data.error.messages;
                        that.errorMessages = ['Er ontbreken gegevens in deze stap'];
                    } else {
                        that.errorMessages = ['Onbekende fout!'];
                    }
                    that.$vuetify.goTo(that.$refs.errorMessages, {
                        duration: 300,
                        offset: 100,
                        easing: 'easeInOutCubic',
                    });
                })
                .finally(function () {
                    that.submitBtnClicked = false;
                    that.submitting = false;
                });
        },
    },
};
</script>
